/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
import type { AutoTaskBase } from './AutoTaskBase';
import { AutoTaskBaseFromJSON, AutoTaskBaseFromJSONTyped, AutoTaskBaseToJSON, } from './AutoTaskBase';
import type { BoundingBoxRelative } from './BoundingBoxRelative';
import { BoundingBoxRelativeFromJSON, BoundingBoxRelativeFromJSONTyped, BoundingBoxRelativeToJSON, } from './BoundingBoxRelative';
/*
causes circular dependendies
// .concat(AutoTaskBaseValidator)

*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 * Create a prediction which crops and focuses on a specific part of the image
 * @export
 * @interface AutoTaskCrop
 *
 */
// create custom validators for the regexes
export interface AutoTaskCrop extends AutoTaskBase {
    /**
     * The bounding boxes to focus on.
     * #type Array<BoundingBoxRelative>
     * #memberof AutoTaskCrop
        
        
         */
    bboxs: Array<BoundingBoxRelative>;
}
/**
 * Check if a given object implements the AutoTaskCrop interface.
 */
export function instanceOfAutoTaskCrop(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "bboxs" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
import { AutoTaskBaseValidator, AutoTaskBaseStringifyShape, AutoTaskBaseStringifyShapeProperties, } from './AutoTaskBase';
import { BoundingBoxRelativeValidator, BoundingBoxRelativeStringifyShape, BoundingBoxRelativeStringifyShapeProperties, } from './BoundingBoxRelative';
export const AutoTaskCropTypiaAssertEquals = (input: any) => {
    return ((input: any): AutoTaskCrop => {
        const __is = (input: any, _exceptionable: boolean = true): input is AutoTaskCrop => {
            const $is_custom = (typia.createAssertEquals as any).is_custom;
            const $join = (typia.createAssertEquals as any).join;
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => Array.isArray(input.bboxs) && input.bboxs.every((elem: any, _index1: number) => "object" === typeof elem && null !== elem && $io1(elem, true && _exceptionable)) && "string" === typeof input.type && ("string" === typeof input.name && $is_custom("pattern_AutoTaskBase_name", "string", "", input.name)) && (3 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["bboxs", "type", "name"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            const $io1 = (input: any, _exceptionable: boolean = true): boolean => "number" === typeof input.length && Object.keys(input).every((key: any) => {
                if (["length"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                    return "number" === typeof value;
                return false;
            });
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is AutoTaskCrop => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $is_custom = (typia.createAssertEquals as any).is_custom;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ((Array.isArray(input.bboxs) || $guard(_exceptionable, {
                    path: _path + ".bboxs",
                    expected: "Array<BoundingBoxRelative>",
                    value: input.bboxs
                })) && input.bboxs.every((elem: any, _index1: number) => ("object" === typeof elem && null !== elem || $guard(_exceptionable, {
                    path: _path + ".bboxs[" + _index1 + "]",
                    expected: "BoundingBoxRelative",
                    value: elem
                })) && $ao1(elem, _path + ".bboxs[" + _index1 + "]", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".bboxs[" + _index1 + "]",
                    expected: "BoundingBoxRelative",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".bboxs",
                    expected: "Array<BoundingBoxRelative>",
                    value: input.bboxs
                })) && ("string" === typeof input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "string",
                    value: input.type
                })) && ("string" === typeof input.name && ($is_custom("pattern_AutoTaskBase_name", "string", "", input.name) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string (@pattern_AutoTaskBase_name)",
                    value: input.name
                })) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string",
                    value: input.name
                })) && (3 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["bboxs", "type", "name"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.length || $guard(_exceptionable, {
                    path: _path + ".length",
                    expected: "number",
                    value: input.length
                })) && (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["length"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                        return "number" === typeof value || $guard(_exceptionable, {
                            path: _path + $join(key),
                            expected: "number",
                            value: value
                        });
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "AutoTaskCrop",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "AutoTaskCrop",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const AutoTaskCropTypiaAssertStringify = (input: AutoTaskCrop): string => {
    return ((input: any): string => { const assert = (input: any): AutoTaskCrop => {
        const __is = (input: any): input is AutoTaskCrop => {
            const $is_custom = (typia.createAssertStringify as any).is_custom;
            const $join = (typia.createAssertStringify as any).join;
            const $io0 = (input: any): boolean => Array.isArray(input.bboxs) && input.bboxs.every((elem: any) => "object" === typeof elem && null !== elem && $io1(elem)) && "string" === typeof input.type && ("string" === typeof input.name && $is_custom("pattern_AutoTaskBase_name", "string", "", input.name));
            const $io1 = (input: any): boolean => "number" === typeof input.length && !Number.isNaN(input.length) && Object.keys(input).every((key: any) => {
                if (["length"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                    return "number" === typeof value && !Number.isNaN(value);
                return true;
            });
            return "object" === typeof input && null !== input && $io0(input);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is AutoTaskCrop => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $is_custom = (typia.createAssertStringify as any).is_custom;
                const $join = (typia.createAssertStringify as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ((Array.isArray(input.bboxs) || $guard(_exceptionable, {
                    path: _path + ".bboxs",
                    expected: "Array<BoundingBoxRelative>",
                    value: input.bboxs
                })) && input.bboxs.every((elem: any, _index1: number) => ("object" === typeof elem && null !== elem || $guard(_exceptionable, {
                    path: _path + ".bboxs[" + _index1 + "]",
                    expected: "BoundingBoxRelative",
                    value: elem
                })) && $ao1(elem, _path + ".bboxs[" + _index1 + "]", true && _exceptionable) || $guard(_exceptionable, {
                    path: _path + ".bboxs[" + _index1 + "]",
                    expected: "BoundingBoxRelative",
                    value: elem
                })) || $guard(_exceptionable, {
                    path: _path + ".bboxs",
                    expected: "Array<BoundingBoxRelative>",
                    value: input.bboxs
                })) && ("string" === typeof input.type || $guard(_exceptionable, {
                    path: _path + ".type",
                    expected: "string",
                    value: input.type
                })) && ("string" === typeof input.name && ($is_custom("pattern_AutoTaskBase_name", "string", "", input.name) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string (@pattern_AutoTaskBase_name)",
                    value: input.name
                })) || $guard(_exceptionable, {
                    path: _path + ".name",
                    expected: "string",
                    value: input.name
                }));
                const $ao1 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("number" === typeof input.length && !Number.isNaN(input.length) || $guard(_exceptionable, {
                    path: _path + ".length",
                    expected: "number",
                    value: input.length
                })) && (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["length"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                        return "number" === typeof value && !Number.isNaN(value) || $guard(_exceptionable, {
                            path: _path + $join(key),
                            expected: "number",
                            value: value
                        });
                    return true;
                }));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "AutoTaskCrop",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "AutoTaskCrop",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: AutoTaskCrop): string => {
        const $io1 = (input: any): boolean => "number" === typeof input.length && Object.keys(input).every((key: any) => {
            if (["length"].some((prop: any) => key === prop))
                return true;
            const value = input[key];
            if (undefined === value)
                return true;
            if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
                return "number" === typeof value;
            return true;
        });
        const $string = (typia.createAssertStringify as any).string;
        const $join = (typia.createAssertStringify as any).join;
        const $tail = (typia.createAssertStringify as any).tail;
        const $is_custom = (typia.createAssertStringify as any).is_custom;
        const $so0 = (input: any): any => `{"bboxs":${`[${input.bboxs.map((elem: any) => $so1(elem)).join(",")}]`},"type":${$string(input.type)},"name":${$string(input.name)}}`;
        const $so1 = (input: any): any => `{${$tail(`"length":${input.length},${Object.entries(input).map(([key, value]: [string, any]) => { if (undefined === value)
            return ""; if (["length"].some((regular: any) => regular === key))
            return ""; if (RegExp(/^[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?$/).test(key))
            return `${JSON.stringify(key)}:${value}`; return ""; }).filter((str: any) => "" !== str).join(",")}`)}}`;
        return $so0(input);
    }; return stringify(assert(input)); })(input);
};
export const AutoTaskCropValidatorShape = {
    'bboxs': yup.array().of(BoundingBoxRelativeValidator).min(1).defined(),
};
export const AutoTaskCropValidator = yup.object().shape(AutoTaskCropValidatorShape).concat(AutoTaskBaseValidator);
export const AutoTaskCropStringifyShapeProperties: ObjectSchema['properties'] = {
    'bboxs': {
        type: 'array',
        items: {
            BoundingBoxRelativeStringifyShape
        }
    },
};
export const AutoTaskCropStringifyShape: ObjectSchema = {
    title: 'AutoTaskCrop Stringifier',
    type: 'object',
    properties: {
        ...AutoTaskBaseStringifyShapeProperties,
        ...AutoTaskCropStringifyShapeProperties
    },
    required: [
        ...(AutoTaskBaseStringifyShape.required ? AutoTaskBaseStringifyShape.required : []),
        'bboxs',
    ],
};
export const AutoTaskCropStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(AutoTaskCropStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const AutoTaskCropStringify: (data: AutoTaskCrop) => string = AutoTaskCropStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function AutoTaskCropFromJSON(json: any): AutoTaskCrop {
    return AutoTaskCropFromJSONTyped(json, false);
}
export function AutoTaskCropFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutoTaskCrop {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
    if (!ignoreDiscriminator) {
    }
*/
    return {
        ...AutoTaskBaseFromJSONTyped(json, ignoreDiscriminator),
        'bboxs': ((json['bboxs'] as Array<any> || []).map(BoundingBoxRelativeFromJSON)),
    };
}
export function AutoTaskCropToJSON(value?: AutoTaskCrop | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...AutoTaskBaseToJSON(value),
        'bboxs': ((value.bboxs as Array<any> || []).map(BoundingBoxRelativeToJSON)),
    };
}
